import './map/custom-map';

//import { coordinates } from './map/coordinates-control';
import { dblclick } from './map/bdclick-handle';

/**
 * Démarre le bon type de carte en fonction de la vue :
 *  - Vue d'un événement
 *  - Vue globale
 * @param {*} params 
 */
export function startMap(params, app) {
    const map = params.has('event')
        ? L.eventMap(params, 'map', app) 
        : L.gendlocMap('map', app);

    if (map) {
        window.map = map;
                
        L.control.scale({metric: true, imperial: false}).addTo(map);
        L.control.polylineMeasure({
            position: 'topleft',
            unit: 'kilometres',
            showBearings: true,
            clearMeasurementsOnStop: false,
            showClearControl: true,
            showUnitControl: true,
            unitControlUnits: ["kilometres", "nauticalmiles"]
        }).addTo(map);

        map.on('dblclick', (event) => dblclick(event.latlng, map));

        //coordinates().addTo(map);
        L.quickCoordinateControl().addTo(map);
        
    }
}